import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import { mq } from "../mixins"
import cx from "classnames"
import { convertContentStackAsset } from "../../utils"
import "./threeColumnCards.scss"
import ModalV2 from "../ModalV2/modalV2.js"

const ThreeColumnCards = props => {
  const threeColumnCardsWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    ${mq("tablet")} {
      margin: 7.5% auto;
    }
    ${mq("desktop")} {
      width: 970px;
    }
  `
  const ThreeColumnCardsContent = styled("div")`
    padding: 3rem 0;
    ${mq("tablet")} {
      padding: 0;
    }
    background-color: ${props =>
      !!props.background_color ? props.background_color : "#fff"};
  `

const ThreeColumnCardsContainer = styled("div")`
    text-align:${props=> props.cardTextAlignment};
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    padding-top: 3rem;
    ${mq("tablet")} {
      justify-content: space-between;
    }
  `

  const Card = styled("div")`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 310px;
    height: ${props => props.overrideHeight || 465}px;
    padding: ${props=> props.hasIcon === true ? '6rem 1rem 2rem' : '2rem 1rem 2rem'};
    margin-bottom: 2rem;
    ${props =>
      !!props.bg.image && !!props.bg.image.url
        ? `background-image: url(${props.bg.image.url}); background-repeat: no-repeat; background-size:cover`
        : `background-color:${props.bg.background_color};`};
        overflow: auto;
`
  return (
    <ThreeColumnCardsContent
      css={threeColumnCardsWrapper}
      className={`three_column_cards_content ${
        props.color_theme === "light" ? "light" : "dark"
      }`}
    >
      {!!props.logo && !!props.logo.url && (
        <img
          src={convertContentStackAsset(props.logo.url)}
          className="logo"
          alt={props.alt_description}
        ></img>
      )}
      {!!props.header && <h2>{props.header}</h2>}
      {!!props.rich_text_editor && (
        <div
          className="sub_header"
          dangerouslySetInnerHTML={{ __html: props.rich_text_editor }}
        ></div>
      )}
      <ThreeColumnCardsContainer
        cardTextAlignment={props.card_text_alignment}
      >
        {props.modular_blocks.map((block, idx) => {
          return (
            <Card
              key={props.uid + idx}
              bg={block.card.background }
              hasIcon= {block.card.is_icon}
              overrideHeight={props.override_card_height}
              className={`card ${
                props.card_color_theme === "light" ? "light" : "dark"
              }`}
            >
              {!!block.card.image && !!block.card.image.url && (
                <img
                  src={convertContentStackAsset(block.card.image.url)}
                  className={cx("card__image",{
                    "card__image--icon": block.card.is_icon === true
                  })}
                  alt={block.card.alt_description}
                ></img>
              )}
              {!!block.card.headline && (
                <h4 className={"card__headline"}>{block.card.headline}</h4>
              )}
              <div className="card__content">
                {!!block.card.body && (
                  <div
                    className={"card__body"}
                    dangerouslySetInnerHTML={{ __html: block.card.body }}
                  ></div>
                )}
                {!!block.card.modal && !!block.card.modal[0] && <ModalV2 data={block.card.modal[0]}/>}
                {!!block.card.link && !!block.card.link.href && (
                  <a className={"card__link"} href={block.card.link.href}>
                    {block.card.link.title}
                  </a>
                )}
              </div>
            </Card>
          )
        })}
      </ThreeColumnCardsContainer>
    </ThreeColumnCardsContent>
  )
}

export default ThreeColumnCards
